import { action } from 'easy-peasy';
import { IActionSetPatientNotificationRules } from '../types';

const setPatientNotificationRules: IActionSetPatientNotificationRules = action((state, payload) => {
  state.items = payload;
});

export default setPatientNotificationRules;
